import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { banners } from '@/mocks/comics';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);
  const total = banners.length;

  const goNext = useCallback(() => {
    setCurrent((prev) => (prev + 1) % total);
  }, [total]);

  useEffect(() => {
    const timer = setInterval(goNext, 5000);
    return () => clearInterval(timer);
  }, [goNext]);

  const banner = banners[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden" aria-label="推荐漫画横幅">
      <div
        className="absolute inset-0 bg-cover bg-center transition-all duration-700"
        style={{ backgroundImage: `url(${banner.image})` }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/60" />

      <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-4 md:px-6 w-full">
        <div className="max-w-[800px] w-full">
          <span className="inline-block text-xs md:text-sm font-medium text-white/80 bg-white/10 backdrop-blur-sm px-4 py-1.5 rounded-full mb-4">
            {banner.subtitle}
          </span>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-4 leading-tight">
            {banner.title}
          </h1>
          <p className="text-sm md:text-lg text-white/80 mb-8 max-w-[500px] mx-auto leading-relaxed">
            {banner.description}
          </p>
          <Link
            to={`/chapter/${banner.comicId}/1`}
            className="inline-flex items-center gap-2 bg-primary-500 text-white px-8 py-3 rounded-full text-sm md:text-base font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            开始阅读 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {banners.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer ${
              index === current ? 'bg-white w-8' : 'bg-white/40 hover:bg-white/70'
            }`}
            aria-label={`切换到第${index + 1}张横幅`}
          />
        ))}
      </div>
    </section>
  );
}